// import Single from "../assets/single.png";
// import Double from "../assets/double.png";
// import Triple from "../assets/triple.png";
import React from "react";
import Single from "./double.png";
import workpermit from "./work-permit.svg";
import maintenance from "./maintenance.svg";
import qr from "./NBHqrcode1.png";

const ShareButton = () => {
  const handleShareClick = () => {
    const textToShare = encodeURIComponent(
      "Check out this awesome link: https://example.com"
    );
    const whatsappUrl = `whatsapp://send?text=${textToShare}`;
    window.location.href = whatsappUrl;
  };

  return <button onClick={handleShareClick}>Apply Now</button>;
};

const Cards = () => {
  return (
    <div className="w-full  px-4 bg-white">
      <div className="max-w-screen-xl mx-auto grid md:grid-cols-2 gap-10">
        <div className="w-full text-white bg-blue-800 shadow-xl flex flex-col p-4 my-4 rounded-lg hover:scale-105 duration-300">
          <img
            className="w-20 mx-auto -mt-12 bg-white"
            src={workpermit}
            alt="work_permit_image"
          />
          <h2 className="text-2xl  font-bold text-center pt-8">WORK PERMIT</h2>
          <p className="text-center text-xl pt-4 font-bold">
            Click to fill work permit
          </p>
          <div className="text-center font-medium">
            <p className="py-2 border-b mx-8 mt-8">
              Approval In 48 Hrs (if all requirements are met)
            </p>
            <p className="py-2 border-b mx-8">Submit Your Documents</p>
            <p className="py-2 border-b mx-8">
              Apply for work permit at least 1 week prior to planned work to
              avoid delays
            </p>
          </div>
          <a
            href="https://forms.office.com/r/NSn75Bs4Xv"
            target="_blank"
            className="text-center"
          >
            <button className="bg-white text-blue-900 w-[200px] rounded-md font-medium my-6 mx-auto px-6 py-3">
              Apply Now
            </button>
          </a>
        </div>

        <div className="w-full shadow-xl text-blue-900 bg-gray-200 flex flex-col p-4 md:my-4 my-8 rounded-lg hover:scale-105 duration-300">
          <img
            className="w-[100px] mx-auto -mt-12 bg-transparent"
            src={maintenance}
            alt="/"
          />
          <h2 className="text-2xl  font-bold text-center pt-4">
            MAINTENANCE REQUEST
          </h2>
          <p className="py-2 text-center text-xl font-bold">
            Submit your application{" "}
          </p>
          <div className="text-center font-medium">
            <p className="py-2 border-b border-blue-900 mx-8 mt-8">
              Available 24 Hrs
            </p>
            <p className="py-2 border-b border-blue-900 mx-8">
              Submit Your Request
            </p>
            <p className="py-2 border-blue-900 border-b mx-8">
              Skilled Workers
            </p>
            <p className="py-2 border-b mx-8"></p>
          </div>
          <a
            href="https://nbhd.co/app/gMqvz"
            target="_blank"
            className="text-center"
          >
            <button className="bg-blue-900 text-white w-[200px] rounded-md font-medium my-6 mx-auto px-6 py-3">
              Apply Now
            </button>
          </a>
        </div>
        <div className="w-full shadow-xl text-blue-900 bg-gray-200 flex flex-col p-4 my-4 rounded-lg hover:scale-105 duration-300">
          <img
            className="w-20 mx-auto -mt-12 bg-white"
            src={qr}
            alt="alghaith_app_qr"
          />
          <h2 className="text-2xl font-bold text-center py-8">
            Register as a Tenant
          </h2>
          <p className="text-center text-xl font-bold">
            Get more use of application
          </p>
          <div className="text-center font-medium">
            <p className="py-2 border-b border-blue-900 mx-8 mt-8">
              Register your complaint easily
            </p>
            <p className="py-2 border-b border-blue-900 mx-8">
              Easy Access to everything
            </p>
            <p className="py-2 border-b border-blue-900 mx-8">Android & IOS</p>
          </div>
          <a
            href="https://nbhd.co/app/gMqvz"
            target="_blank"
            className="text-center"
          >
            <button className="bg-blue-900 text-white w-[200px] rounded-md font-medium my-6 mx-auto px-6 py-3">
              Download Now
            </button>
          </a>
        </div>

        <div className="w-full text-white bg-blue-800 shadow-xl flex flex-col p-4 my-4 rounded-lg hover:scale-105 duration-300">
          <img
            className="w-20 mx-auto -mt-12 bg-white"
            src={workpermit}
            alt="work_permit_image"
          />
          <h2 className="text-2xl  font-bold text-center pt-8">Contractor/Supplier</h2>
          <p className="text-center text-xl pt-4 font-bold">
            Register your company with Al Ghaith Properties
          </p>
          <div className="text-center font-medium">
            <p className="py-2 border-b mx-8 mt-8">
              Submit your company details
            </p>
            <p className="py-2 border-b mx-8">Submit Your Contact Details</p>
            <p className="py-2 border-b mx-8">
              Submit your Bank Details
            </p>
          </div>
          <a
            href="https://forms.gle/XkVPjbhxtNZXTvvs6"
            target="_blank"
            className="text-center"
          >
            <button className="bg-white text-blue-900 w-[200px] rounded-md font-medium my-6 mx-auto px-6 py-3">
              Click to Register
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};
export default Cards;
